import React, { Component } from 'react';
import ImageUp from './../images/images-master/icons-svg/flecha-hacia-arriba.svg'
import TitleAlt from './../atoms/TitleAlt.jsx'

class ButtonHeader extends Component {
    constructor(props) {
        super(props) 

        this.buttonDireccion = this.buttonDireccion.bind(this)
    }

    buttonDireccion() {
        window.location.href="#"
    }

    render() {
        return (
            <div className="button-up" id="buttonup" onClick={this.buttonDireccion} >
                    <img src={ImageUp} alt={TitleAlt} />
            </div>
        )
    }
}

export default ButtonHeader;
